// Copying text (code, a file's link) and saying so in a toast.
import { m } from "@trameria/i18n";
import { toast } from "../../ui/toast";

export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    toast(m.blocks_copied());
    return true;
  } catch {
    toast(m.blocks_copy_failed());
    return false;
  }
}
